export class AppointmentHubServiceBundle extends DrupalBehavior {
  onReady(context) {
    const seeMoreBtns = once(
      'service-bundle-see-more',
      '.appointment-hub--service-bundle--card.btn--see-services',
      context
    );
    const hiddenCardsDrawer = once(
      'service-bundle-hidden-drawer',
      '.appoint-hub-service-bundle--drawer',
      context
    );
    const $btn = seeMoreBtns[0];

    // Add an event listener to the trigger element after the DOM loads
    $btn.addEventListener('click', (e) => {
      e.preventDefault();
      $(hiddenCardsDrawer[0]).removeClass('closed');
      $($btn.parentElement).addClass('hidden');
    });
  }
}

DrupalBehavior.register(
  'rush_theme.components',
  'appointment_hub_service_bundle',
  AppointmentHubServiceBundle
);
